export default __webpack_public_path__ + "static/char-s-40-en-be86d0ab51ab63695aedbce26e663714.png";